import Vue from 'vue';

Vue.component('chapter', () => import(/* webpackChunkName: "ui" */ '~/components/ui/chapter'));
